import { createBrowserRouter, RouterProvider } from "react-router-dom";
/** Pages Import */
import Login from "../Pages/Login";
import Drawer from "./Drawer";
/** 승무원 메뉴 */
import AutoDispatch from "../Pages/AutoDispatch"; // 자동배차
import Holiday from "../Pages/Holiday"; // 휴무관리
import Education from "../Pages/Education"; // 교육관리
import AddWork from "../Pages/AddWork"; // 근무신청
/** ========== */
/** 정비원 메뉴 */
import ChangeCar from "../Pages/ChangeCar"; // 대차처리
import AccidentCar from "../Pages/AccidentCar"; // 사고고장처리
import EmptyCar from "../Pages/EmptyCar"; // 공차운행
/** ========== */
/** 관리자 메뉴 */
import AdminAutoDispatch from "../Pages/AdminAutoDispatch"; // 자동배차
import Mornitoring from "../Pages/Monitoring"; // 모니터링
import AdminFacilities from "../Pages/AdminFacilities"; // 시설물
import AdminHoliday from "../Pages/AdminHoliday"; // 휴무관리
import AdminAddWork from "../Pages/AdminAddWork"; // 근무관리
import AdminEducation from "../Pages/AdminEducation"; // 교육관리
/** ========== */
import Setting from "../Pages/Setting"; // 설정
import Notices from "../Pages/Setting/Notices"; // 공지사항
import Error from "../Pages/Error"; // 에러 페이지

const router = createBrowserRouter([
  {
    path: "/",
    Component: Login,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    path: "/",
    Component: Drawer,
    children: [
      {
        path: "/AutoDispatch",
        element: <AutoDispatch />,
      },
      {
        path: "/Holiday",
        element: <Holiday />,
      },
      {
        path: "/Education",
        element: <Education />,
      },
      {
        path: "/AddWork",
        element: <AddWork />,
      },
      {
        path: "/ChangeCar",
        element: <ChangeCar />,
      },
      {
        path: "/AccidentCar",
        element: <AccidentCar />,
      },
      {
        path: "/EmptyCar",
        element: <EmptyCar />,
      },
      {
        path: "/AdminAutoDispatch",
        element: <AdminAutoDispatch />,
      },
      {
        path: "/Mornitoring",
        element: <Mornitoring />,
      },
      {
        path: "/AdminFacilities",
        element: <AdminFacilities />,
      },
      {
        path: "/AdminHoliday",
        element: <AdminHoliday />,
      },
      {
        path: "/AdminAddWork",
        element: <AdminAddWork />,
      },
      {
        path: "/AdminEducation",
        element: <AdminEducation />,
      },
      {
        path: "/Setting",
        element: <Setting />,
      },
      {
        path: "/Notices",
        element: <Notices />,
      },
    ],
  },
  {
    path: "/error-page",
    element: <Error />,
  },
]);

function Router() {
  return <RouterProvider router={router} />;
}

export default Router;
